import { useCallback, useRef } from 'react';
import useFocusEffect from './useFocusEffect';
import { useNavigation } from './useNavigation';
import { useQuery } from './useQuery';
import { webLogger } from '@/common/log';
import { appVersion, isAndroidKDS } from '@/common/device-info';
import { versionCompare } from '@kibt/web-utils/version';

export interface PvOptions {
    bundleId: string;
    componentName: string;
    pageMap: () => {
        page: string;
        params?: object;
        contentPackage?: object;
    };
}

export function useAutoPv() {
    const navigation = useNavigation();
    const componentName = useQuery('componentName');
    const pvParamsRef = useRef<PvOptions>();
    const beginTimeRef = useRef(Date.now());

    const sendPv = (type: 'visible' | 'enter' | 'leave' | 'hidden') => {
        const { page = componentName, params = {}, contentPackage = {} } = pvParamsRef.current ? pvParamsRef.current.pageMap() : {};

        let options: any = { type };
        switch (type) {
            case 'enter':
                options = {
                    type,
                    page,
                    params,
                    contentPackage,
                };
                beginTimeRef.current = Date.now();
                console.log(`[autoPv] ${componentName}页面， 监听到页面进入`);
                break;
            case 'visible':
                options = {
                    type: 'enter',
                    page,
                    params,
                    contentPackage,
                };
                beginTimeRef.current = Date.now();
                console.log(`[autoPv] ${componentName}页面， 监听到页面Resume`);
                break;
            case 'leave':
                // 传入 enter 时的 beginTime，会上报停留时长
                options.beginTime = beginTimeRef.current;
                console.log(`[autoPv] ${componentName}页面， 监听到页面销毁`);
                break;
            case 'hidden':
                options = {
                    type,
                };
                console.log(`[autoPv] ${componentName}页面， 监听到页面切入后台`);
                break;
        }

        webLogger.webLogger.collect('PV', options);
        console.log(`MyLog [autoPv] ${componentName}页面， 发送埋点 ${type}`, JSON.stringify({ type, page }));
    };

    // useEffect(() => {
    //     const unBeforeRemove = navigation?.addListener('beforeRemove', () => {
    //         // console.log('MyLog autopv leave');
    //         // sendPv('leave');
    //     });

    //     return () => {
    //         unBeforeRemove?.();
    //     };
    // }, []);

    const focusCountRef = useRef(0);

    useFocusEffect(
        useCallback(() => {
            if (focusCountRef.current > 0) {
                // Anroid 10.2.20新增spa resume临时处理方案
                if (isAndroidKDS) {
                    if (versionCompare(appVersion, '10.2.20') >= 0) {
                        const { page = componentName, params = {}, contentPackage = {} } = pvParamsRef.current ? pvParamsRef.current.pageMap() : {};
                        webLogger.webLogger.collect('PV', {
                            type: 'enter',
                            page,
                            params: {
                                pageLifecycle: 'resume',
                                ...params,
                            },
                            contentPackage,
                        });
                    } else {
                        sendPv('enter');
                    }
                } else {
                    // iOS不需要处理，iOS自己会记录resume，容器退出后会统一批量自行上报resume、leave事件
                    // sendPv('enter');
                }
            } else {
                focusCountRef.current++;
            }
        }, []),
    );

    /**
     * PV 手动上包PV
     * visible' | 'enter' | 'leave' | 'hidden'
     */
    const sendAsyncPV = (options: PvOptions) => {
        // 保存options
        pvParamsRef.current = options;
        // 上报PV
        sendPv('enter');
    };

    return {
        sendAsyncPV,
    };
}
